import { BackgroundImage } from './background-image'
import { Image } from './Image'
import NextImage from './next-image'

export { BackgroundImage, Image, NextImage }
